import { ContractResponse } from '@/types/api/v1/ContractInfoResponse';
import api from '@/utils/api';
import { getSigV4HeadersForGet } from '@/utils/cognito';
import { ApiUrl } from '@/utils/constants';
import { AxiosResponse } from 'axios';
import { useCallback } from 'react';

const url = ApiUrl.Read.CONTRACT_INFO;

const useGetContractInfo = () => {
  const execute = useCallback(async (): Promise<AxiosResponse<ContractResponse>> => {
    const headers = await getSigV4HeadersForGet(url);
    return api.get(url, headers);
  }, []);

  return { execute };
};

export default useGetContractInfo;
